import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_PaginatedResourceTable = _resolveComponent("PaginatedResourceTable")!
  const _component_rc_button = _resolveComponent("rc-button")!
  const _component_Masthead = _resolveComponent("Masthead")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.hiddenHarvesterCount)
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 0,
          color: "info",
          label: _ctx.t('cluster.harvester.clusterWarning', {count: $options.hiddenHarvesterCount} )
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    ($options.isExplorer)
      ? (_openBlock(), _createBlock(_component_PaginatedResourceTable, {
          key: 1,
          schema: $data.provClusterSchema,
          "query-fields": $options.provPinnedQueryFields,
          "local-filter": $options.filterProvRowsLocal,
          "api-filter": $options.filterProvRowsApi
        }, null, 8, ["schema", "query-fields", "local-filter", "api-filter"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_Masthead, {
            schema: $data.provClusterSchema,
            resource: $data.provClusterSchema.id,
            "create-location": $options.createLocation,
            "component-testid": "cluster-manager-list"
          }, _createSlots({ _: 2 }, [
            ($options.canImport)
              ? {
                  name: "extraActions",
                  fn: _withCtx(() => [
                    _createVNode(_component_rc_button, {
                      size: "large",
                      class: "mr-10",
                      to: $options.importLocation,
                      "data-testid": "cluster-manager-list-import"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('cluster.importAction')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["schema", "resource", "create-location"]),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createVNode(_component_PaginatedResourceTable, {
            schema: $data.mgmtClusterSchema,
            "query-fields": $options.pinnedQueryFields,
            headers: $data.headers,
            "pagination-headers": $data.paginationHeaders,
            context: $data.paginationContext,
            "use-query-params-for-simple-filtering": true,
            "local-filter": $options.filterRowsLocal,
            "api-filter": $options.filterRowsApi,
            "fetch-secondary-resources": $options.fetchSecondaryResources,
            "fetch-page-secondary-resources": $options.fetchPageSecondaryResources,
            groupable: $options.nonStandardWorkspace,
            namespaced: true,
            "data-testid": 'cluster-list'
          }, null, 8, ["schema", "query-fields", "headers", "pagination-headers", "context", "local-filter", "api-filter", "fetch-secondary-resources", "fetch-page-secondary-resources", "groupable"])
        ], 64))
  ]))
}